import React from 'react';
import { useNavigate } from 'react-router-dom';
import AberturaLaudoOrquestrador from './criacao/AberturaLaudo_Orquestrador';

export default function NovoLaudo() {
  const navigate = useNavigate();

  // Quando o wizard conclui, ele retorna { id, codigo_mh, esfera }
  const handleConcluir = (resposta) => {
    console.log('Laudo criado:', resposta);

    // Redireciona pra aba ABERTURA do laudo criado
    if (resposta?.codigo_mh) {
      navigate(`/laudos/${resposta.codigo_mh}/abertura`);
    } else {
      // Fallback — volta pra lista
      navigate('/laudos');
    }
  };

  return (
    <div className="min-h-screen bg-[#050810] text-slate-200 p-8">
      <div className="max-w-5xl mx-auto">
        <AberturaLaudoOrquestrador onConcluir={handleConcluir} />
      </div>
    </div>
  );
}